<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-fit icon-arrow-back" aria-hidden="true"></svg>
                </a>
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <template v-if="payment_cards != null">

                <div class="content-inner">

                    <div class="main-header">Payment cards</div>
                    <div class="sub-header-lite">{{ payment_cards.length }} {{ filters.pluralise(payment_cards.length, 'card') }}</div>

                    <v-ons-list class="section-h" data-test-id="cnt-cards">
                        <v-ons-list-item
                                v-for="card in payment_cards"
                                v-bind:key="card.id">
                            <div class="center">
                                <span class="card-number">
                                    <span v-for="i in [1,2,3]" v-bind:key="i" class="card-dots">
                                        ••••
                                    </span> 
                                    {{ card.last_4 }}
                                </span>
                                <div class="card-name">
                                    <span v-if="helpers.stringEmpty(card.name) == false">{{card.name}}, </span>
                                    <span>{{ card.brand }}</span>
                                    <span> - {{ filters.cardDateFormat(card.expires_at) }}</span>
                                </div>
                                <div class="preffered-container"> 
                                    <span class="default-text active" v-show="card.is_default">Default card</span>
                                    <span class="default-text pressable"
                                        v-on:click="setDefault(card.id)"
                                        v-show="card.is_default == false" >
                                        Set as default</span>
                                </div>
                            </div>
                            <div class="right">
                                 <i class="fa fa-trash pressable" aria-hidden="true"
                                    v-on:click="deleteCard(card.id)"></i>
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                </div>
            </template>
        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        data () {
            return {
                app: this.$root.$data.app,
                payment_cards: null,
                deleting: false
            }
        },

        mounted(){
            this.getPaymentCards()
        },

        methods: {
            setDefault(card_id) {
                this.app.http.post(`payment_card/${card_id}/preferred`)
                    .then(response => {
                        this.$ons.notification.alert(
                            response.data.message,
                            { title: 'Success' }
                        )
                        this.getPaymentCards()
                    })
                    .catch(error => {
                        this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Error' }
                        )
                    })
            },

            getPaymentCards(){
                this.app.http.get('payment_cards')
                    .then(response => {
                        this.payment_cards = response.data.payment_cards
                    })
                    .catch(error => {})
            },

            deleteCard(card_id) {
                if (this.deleting)
                    return
                    
                this.$ons.notification.confirm(
                        'Are you sure you want to delete this card?',
                        { title: 'Confirm' }
                    )
                    .then((result) => {
                        if (result != 1)
                            return Promise.reject()

                        this.deleting = true
                        this.app.http.delete(`payment_card/${card_id}`)
                            .then(response => {
                                this.deleting = false
                                this.$ons.notification.alert(
                                    response.data.message,
                                    { title: 'Success' }
                                )
                                this.getPaymentCards()
                            })
                            .catch(error => {
                                this.deleting = false
                                this.$ons.notification.alert(
                                    this.app.getResponseErrorMessage(error),
                                    { title: 'Error' }
                                )
                            })
                    })
            }
        },

        computed: {
            ...mapGetters([]),

            show_loading: function(){
                return this.payment_cards == null || this.deleting
            },
        },
    }
</script>

<style scoped>
    .list-item--chevron:before {
        border-color: #1A1824;
    }

    .card-number {
        font-weight: bold;
        color: var(--global-goodtill-black);
    }

    .card-name {
        font-size: 14px;
        color: var(--global-goodtill-black);
        opacity: 0.5;
        width: 100%;
        margin-top: 5px;
    }

    .default-text {
        font-size: 13px;
        margin-right: 10px;
        color: var(--global-goodtill-black);
    }

    .default-text.active {
        color: var(--global-goodtill-green);
        font-weight: bold;
    }

    .preffered-container {
        font-size: 14px;
        color: var(--global-goodtill-black);
        width: 100%;
        margin-top: 10px;
    }
</style> 


// WEBPACK FOOTER //
// src/js/components/user/payment_cards.vue